export const MedicalCenter = {
    path: '/medical_centers',
    name: 'medical_centers',
    component: () => import('@/views/Medical/Center/MedicalCenterPage.vue'),
    children: [
        {
            path: '/medical_centers/add',
            name: 'medical_centers.add',
            component: () => import('@/views/Medical/Center/Form/MedicalCenterForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/medical_centers/edit/:id',
            name: 'medical_centers.edit',
            component: () => import('@/views/Medical/Center/Form/MedicalCenterForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/medical_centers/delete/:id',
            name: 'medical_centers.delete',
            component: () => import('@/views/Medical/Center/Form/MedicalCenterForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/medical_centers/view/:id',
            name: 'medical_centers.view',
            component: () => import('@/views/Medical/Center/Form/MedicalCenterForm.vue'),
            props: {viewAction: true}
        }
    ]
}